import { Button } from '@mui/material';
import { FC, useCallback } from 'react';
import { useCurrentModule } from 'src/hooks/useCurrentModule';
import { useDrawerState } from 'src/hooks/useDrawerState';
import { recordAction } from 'src/infrastructure/telemetry';

interface AuditLogButtonProps {
    loading?: boolean;
}

export const AuditLogButton: FC<AuditLogButtonProps> = ({ loading = false }) => {
    const { setAuditLogDrawerOpen } = useDrawerState();
    const module = useCurrentModule();

    const showAuditLog = useCallback(() => {
        setAuditLogDrawerOpen(true);
        recordAction('audit-log', {
            ...(module && { module }),
            open: true,
        });
    }, [setAuditLogDrawerOpen, module]);

    return (
        <Button onClick={showAuditLog} variant="text" color="primary" disabled={loading}>
            Audit Log
        </Button>
    );
};
